import {ChartAggOption} from '../../../generated/graphql';
import {Line} from '../../../util/plotHelpers/types';
import {BIN_POINT_TO_USE} from './../../../util/plotHelpers/chartTypes';
import {PointWithMeta} from './buildPoints';
import {parseHistory} from './parseHistory';
import {HistoryRecord} from './types';

export function addSmoothedLineFromBackend(
  line: Line,
  {
    agg,
    behavior,
    emaMetric,
    finitePoints,
    groupAgg,
    isRunsetGrouped,
    matchedHistory,
    xAxis,
    xMetrics,
  }: {
    agg: 'Avg' | 'minMax';
    behavior: {
      usingExpressions: boolean;
    };
    emaMetric: string;
    finitePoints: PointWithMeta[];
    isRunsetGrouped: boolean;
    groupAgg?: ChartAggOption;
    matchedHistory: Record<string, any>[];
    xAxis: string;
    xMetrics: string[];
  }
) {
  const finiteByX = new Map<number, PointWithMeta>();
  finitePoints.forEach(p => {
    finiteByX.set(p.x, p);
  });

  const emaPoints = parseHistory(
    matchedHistory as HistoryRecord[],
    emaMetric,
    xAxis,
    xMetrics.filter(x => x !== xAxis),
    {
      agg,
      startTime: {
        value: line.startTimeInMs!,
        unit: 'milliseconds',
      },
      usingExpressions: behavior.usingExpressions,
    },
    // we don't allow targeting min/max outside of groups currently
    isRunsetGrouped
      ? groupAgg
      : (BIN_POINT_TO_USE.toLowerCase() as ChartAggOption)
  );

  // Create a complete EMA line.
  const emaLine: Line = {
    ...line,
    smoothed: true,
    meta: {
      ...line.meta,
      category: 'smoothed',
    },
    data: emaPoints.finitePoints.map(p => ({
      x: p.x,
      y: p.y,
      legendData: {
        original: finiteByX.get(p.x)?.y,
      },
    })),
  };

  line.smoothedLineFromBackend = emaLine;
}
